"use client";

import { createFileRoute } from "@tanstack/react-router";
import { MotionValue } from "motion/react";
import { CoplaneFooter } from "../components/layout/CoplaneFooter";
import { PageHeader } from "../components/layout/PageHeader";
import { SnapSection } from "../components/layout/SnapSection";
import {
    AutomationAgentsSection,
    AutomationRulesSection,
    AutomationTasksSection,
    IntegrationsSection,
} from "../components/sections";
import { SmoothScrollProvider } from "../context/SmoothScrollContext";
import { ViewportProvider } from "../context/ViewportContext";
import { useDocumentScrollLock } from "../hooks/useDocumentScrollLock";

export const Route = createFileRoute("/platform" as any)({
  component: Page,
});

function Page() {
  return (
    <ViewportProvider>
      <SmoothScrollProvider>
          <PageContent />
      </SmoothScrollProvider>
    </ViewportProvider>
  );
}

function PageContent() {
  useDocumentScrollLock();
  
  const navBgColor = `rgba(255, 255, 255, 1)`;
  const navTextColor = `rgb(35, 31, 32)`;  
  const navBorderColor = `rgba(229, 229, 229, 0)`;

  const navStyles = {
    backgroundColor: navBgColor,
    borderColor: navBorderColor,
    textColor: navTextColor,
    hoverTextColor: navTextColor,
    hoverBgColor: "rgba(128, 128, 128, 0.2)", // Works on both
    activeBgColor: "rgba(128, 128, 128, 0.3)",
    activeTextColor: navTextColor,
  };

  const platformSections = [
    {
      id: "AUTOMATION_AGENTS",
      content: <AutomationAgentsSection />,
    },
    {
      id: "AUTOMATION_RULES",
      content: <AutomationRulesSection />,
    },
    {
      id: "AUTOMATION_TASKS",
      content: <AutomationTasksSection />,
    },
    {
      id: "INTEGRATIONS",
      content: <IntegrationsSection />,
    },
  ];

  return (
    <div
      id="page"
      className="relative w-screen min-h-screen overflow-x-hidden bg-white"
    >
      <main className="relative z-1 flex flex-col text-black">
        <header className="relative z-1 bg-white">
          <PageHeader
            inlineLogo={true}
            navStyles={navStyles}
            hideHamburgerUntil={0 as unknown as MotionValue<number>}
          />
        </header>

        {platformSections.map(({ id, content }) => (
          <SnapSection key={id} id={id}>
            {content}
          </SnapSection>
        ))}
      </main>
      <CoplaneFooter />
    </div>
  );
}
